<template>
  <vx-card class="min-h-screen">
		<ResponseAlert ref="response" />
		<vs-table
			:sst="true"
			@sort="sort"
      :data="config.rows"
		>
			<template slot="header">
				<vs-row>
					<vs-col class="mt-5" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
						<vs-row
							class="justify-between"
							vs-type="flex" vs-w="12">
							<vs-col vs-lg="5" vs-sm="5" vs-xs="12">
								<vs-button
									v-for="type in masters.types"
									:key="type.value"
									class="rounded-sm"
									:class="{'text-primary': type.value !== models.type}"
									:color="type.value === models.type ? 'primary' : '#fff'"
									type="filled"
									@click="models.type = type.value"
									>{{type.text}}
								</vs-button>
							</vs-col>
						</vs-row>
					</vs-col>
					<vs-col class="my-3" vs-type="flex" vs-align="center" vs-w="12">
						<vs-button @click="addOrder" class="w-1/6" color="primary" type="filled" icon="add">Add New</vs-button>
					</vs-col>
				</vs-row>
      </template>
			<template slot="thead">
				<vs-th :sort-key="row.value" v-for="(row, key) in config.headers" :key="key" :width="row.width" :class="row.class">
					{{row.title}}
				</vs-th>
			</template>
			<template slot-scope="{data}">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" >
					<vs-td :data="data[indextr].name">
						{{data[indextr].name || '-'}}
					</vs-td>

					<vs-td :data="data[indextr].order">
						{{data[indextr].order}}
					</vs-td>

					<vs-td class="flex">
						<feather-icon @click="editOrder(data[indextr])" icon="EditIcon" svgClasses="w-5 h-5 mr-3 stroke-current cursor-pointer" />
            <feather-icon @click="destroy(data[indextr].id)" icon="TrashIcon" svgClasses="w-5 h-5 stroke-current cursor-pointer text-black text-opacity-50" />
          </vs-td>
				</vs-tr>
			</template>
		</vs-table>

		<Pagination :config="config" @gotoPage="gotoPage"/>

    <vs-popup title="Add Chat/Group" :active.sync="popupActivo">
      <form @submit.prevent.stop="createOrderChat">
        <div class="w-full mb-5">
          <label for="type">Select Chat</label>
          <v-select
            class="w-full"
            :options="masters.channels.options"
            label="subject"
            :reduce="channel => channel.id"
            v-model="models.channelId"/>
        </div>
        <vs-input type="number" class="w-full mt-2" label="Urutan Chat" v-model="models.order"/>

        <div class="w-full">
          <div class="w-full md:w-1/2 flex md:ml-auto mt-5">
            <vs-button @click="popupActivo = false" class="px-0 w-full mr-1" color="danger">Cancel</vs-button>
            <vs-button button="submit" :disabled="!(models.channelId && models.order !== '')" @click.prevent="createOrderChat" class="px-0 w-full" color="success">Save</vs-button>
          </div>
        </div>
      </form>
    </vs-popup>
	</vx-card>
</template>

<script>
import {checkValidationNumber} from '@/utils/helpers'
import api from '@/utils/api'
export default {
		name: 'ListChatManagement',
		data() {
			return {
        popupActivo: false,
				popupEdit: false,
				checkValidationNumber,
				config: {
					uri: this.$route.meta.link,
					api: '',
					rows: [],
					total_data: 0,
					total_page: 0,
					per_page: 10,
					page: 1,
					orderby: "order",
					sort: "asc",
					debounce: null,
					headers: [{
						title: "Name",
						value: "",
						align: "text-left",
						width: "40%",
					}, {
						title: "Order",
						value: "order",
						align: "text-left",
						width: "30%",
					},{
						title: "Action",
						value: "",
						class: "text-center",
						width: "30%",
					}],
				},
				models: {
          type: 'recommendation',

          channelId: null,
          order: '',
					id: ''
        },
				masters: {
					types: [
						{
							text: 'Recommendation',
							value: 'recommendation'
						},
						{
							text: 'Trending',
							value: 'trending'
						}
					],
          channels: {
            groups: [],
            officials: [],
            options: []
          }
				},
			}
		},
		created() {
			const _ = this;
			_.get()
      _.getMasterOptions()
		},
    computed: {
      channelType() {
        return this.models.type
      }
    },
		methods: {
			get() {
        this.config.api = `${api.chatManagement}/${this.models.type}`
				this.$table.get(this.config)
			},
      getMasterOptions() {
        const getChannelsGroups = this.$axios.get(api.misc_channels_group)
        const getChannelsOfficials = this.$axios.get(api.misc_channels_official)

        Promise.all([getChannelsGroups, getChannelsOfficials]).then(res => {
          const channelsGroups = res[0].data.data.map(channel => {
              return {
                ...channel,
                subject: channel.detail.subject
              }
            }
          )
          const channelsOfficials = res[1].data.data.map(channel => {
              return {
                ...channel,
                subject: channel.detail.subject
              }
            }
          )
          this.masters.channels.officials = this.masters.channels.options = channelsOfficials
          this.masters.channels.groups = channelsGroups
        })
      },
			sort(orderby) {
				if(orderby !== "") this.$table.sort(this.config, orderby)
			},
			gotoPage(page) {
				this.$table.gotoPage(this.config, page)
			},
			handleSearch() {
				clearTimeout(this.debounce)
				this.debounce = setTimeout(() => {
          this.config.page = 1
					this.get()
				}, 500)
			},
      createOrderChat() {
        this.popupActivo = false
				let request = ""

				if(!this.popupEdit) {
					request = this.$axios.post(this.config.api, { channelId: this.models.channelId, order: this.models.order })
				} else {
					request = this.$axios.put(`${this.config.api}/${this.models.id}`, { channelId: this.models.channelId, order: this.models.order })
				}
				request
          .then(() => {
						this.$showToast('Success', `Success Ordering Channel`)
						this.models.channelId = null
						this.models.order = ''
						this.models.id = ''
						this.popupEdit = false
						this.get()
          })
          .catch(error => {
            this.$refs.response.setResponse(error.response.data, 'danger')
          });
      },
      addOrder() {
        this.models.channelId = null
        this.models.order = ''
				this.models.id = ''
        this.popupActivo = true
      },
      editOrder(data) {
        this.models.channelId = data.channelId
        this.models.order = data.order
				this.models.id = data.id
        this.popupActivo = true
				this.popupEdit = true
      },
      destroy(id) {
				this.$vs.dialog({
					type: "confirm",
					color: "danger",
					title: "Confirm",
					text: "Are you sure want to delete this data?",
					acceptText: "Yes",
					cancelText: "No",
					accept: () => {
						this.$axios.delete(`${this.config.api}/${id}`)
						.then(res => {
							this.$refs.response.setResponse(res.data, 'success');
							this.get()
						})
						.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'))
					}
				})
			},
		},
    watch: {
      channelType() {
        this.masters.channels.options = this.channelType === 'recommendation' ? this.masters.channels.officials : this.masters.channels.groups
        this.get()
      },
      'config.per_page'() {
        this.config.page = 1
        this.get()
      }
    },
	}
</script>

<style>

</style>
